import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import {Injectable, OnDestroy} from '@angular/core';
@Injectable({
  providedIn: 'root',
})

export class DemoConfigFilterCommandHandler implements IPlatformCommandHandler, OnDestroy {
  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    handler.executeCommand(command);
    return true;
  }

  ngOnDestroy(): void {
  }

}
